import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, EnvelopeSimple, Bank } from "@phosphor-icons/react";
import { useT } from "../i18n";
import { LOGO_URL } from "./Reveal";

const Footer = () => {
  const { t } = useT();
  return (
    <footer data-testid="footer" className="bg-[#0B111A] text-white/70 relative z-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="bg-white inline-block px-4 py-3 rounded-sm">
            <img src={LOGO_URL} alt="YADIMMO" className="h-8 w-auto" />
          </div>
          <p className="mt-5 max-w-sm font-display text-lg text-white/90">{t("footer.tagline")}</p>
          <div className="mt-6 inline-flex items-center gap-3 bg-white rounded-xl px-4 py-3">
            <img src="/cam-logo.jpg" alt="Crédit Agricole du Maroc" className="h-9 w-auto object-contain" />
            <span className="text-xs text-navy font-medium max-w-[150px]">{t("hero.badge")}</span>
          </div>
        </div>

        <div>
          <h4 className="overline text-gold mb-4">{t("footer.quick")}</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-gold transition-colors">{t("nav.home")}</Link></li>
            <li><Link to="/biens" className="hover:text-gold transition-colors">{t("nav.catalog")}</Link></li>
            <li><Link to="/connexion" className="hover:text-gold transition-colors">{t("nav.login")}</Link></li>
            <li><Link to="/inscription" className="hover:text-gold transition-colors">{t("nav.register")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline text-gold mb-4">{t("footer.contact")}</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin size={18} weight="light" className="mt-0.5 shrink-0 text-gold" /> <span><b className="text-white/90">Bureau France</b><br/>Aix-en-Provence</span></li>
            <li className="flex items-start gap-2"><MapPin size={18} weight="light" className="mt-0.5 shrink-0 text-gold" /> <span><b className="text-white/90">Bureau Maroc</b><br/>Marrakech</span></li>
            <li className="flex items-center gap-2"><Phone size={18} weight="light" /> +212 5 22 00 00 00</li>
            <li className="flex items-center gap-2"><EnvelopeSimple size={18} weight="light" /> contact@yadimmo.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 text-xs text-white/50 flex flex-col sm:flex-row justify-between gap-3">
          <span>© {new Date().getFullYear()} YADIMMO. {t("footer.rights")}</span>
          <div className="flex gap-4">
            <Link to="/cgv" className="hover:text-gold transition-colors">CGV</Link>
            <Link to="/confidentialite" className="hover:text-gold transition-colors">Confidentialité</Link>
            <Link to="/mentions-legales" className="hover:text-gold transition-colors">Mentions légales</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
